module.exports = __webpack_public_path__ + "static/media/branch-detail-375.3b8aeec7.webp";